<template>
  <div class="big">
    <div class="container">
      <!-- 轮播图-->
      <div class="block">
        <el-carousel height="600px">
          <el-carousel-item v-for="(item, index) in bannerImgs" :key="index">
            <img :src="item.img" style="width: 100%;height: auto" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 第二版--公司新闻开始 -->
      <div class="midCompany">
        <el-carousel class="carousel" height="100%">
          <el-carousel-item v-for="(item, index) in newsArr" :key="index">
            <router-link to="" @click.native="routerFun(item)"><img :src="item.filePath"
                style="height: 100%;" /></router-link>
          </el-carousel-item>
        </el-carousel>
        <div class="midContent">
          <div class="midContents">
            <div class="midTit">
              <span class="midTitBox" @mouseenter="mouseEnterFun(item.type)" v-for="(item, index) in tabList">{{ item.type
              }}</span>
            </div>
            <div class="more" @click="moreFun('news')">更多>></div>
          </div>
          <div>
            <div v-for="(item, index) in nesCont" :key="index">
              <div class="newsTit">
                <router-link to="" @click.native="routerFun(item)"
                  style="width: 75%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{ item.Title
                  }}</router-link>
                <span style="width: 20%;text-align: center">{{
                  item.CreationTime
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二版--公司新闻结束 -->

      <!-- 第二版--资质荣誉开始 -->
      <!-- <div class="zzStart">
        <div style="width: 40%">
          <div class="zzStyle">
            <span class="zzTit">
              资质荣誉
            </span>
            <span
              class="more"
              style="line-height: 30px"
              @click="moreFun('quality')"
            >
              更多>>
            </span>
          </div>
          <el-carousel style="margin-top: 10px">
            <el-carousel-item v-for="(item, index) in qualityArr" :key="index">
              <router-link to="/" @click.native="routeFun(2)"
                ><img :src="item.filePath" style="width: 100%;"
              /></router-link>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="midContent" style="width: 60%">
          <div class="midContents">
            <div class="midTit">
              <span class="midTitBox" @mouseenter="mouseEnterFun"
                >社会责任实践</span
              ><span style="color: #ccc;font-size: 15px;font-weight: 500"
                >|</span
              >
              <span class="midTitBox" @mouseenter="mouseEnterFun"
                >公益慈善</span
              >
            </div>
            <div class="more" @click="moreFun('socity')">更多>></div>
          </div>
          <div>
            <div v-for="(item, index) in socialCont" :key="index">
              <div class="newsTit">
                <router-link
                  to=""
                  @click.native="routerSocialFun(item)"
                  style="width: 75%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
                  >{{ item.Title }}</router-link
                >
                <span style="width: 20%;text-align: center">{{
                  item.CreationTime
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 第二版--资质荣誉结束 -->

      <!-- 第二版--业务领域开始 -->
      <!-- <div>
        <div class="zzStyle ywStyle">
          <span class="zzTit">
            业务领域
          </span>
          <span class="more" style="line-height: 30px" @click="moreFun('ywArea')">
            更多>>
          </span>
        </div>
        <div class="bottomPic">
          <div style="width: 32%;height: 100%">
            <img :src="bussinessArr[0].filePath" alt="" style="width: 100%;height: 100%" />
          </div>
          <div style="width: 32%;display: flex;justify-content: space-between;flex-direction: column;">
            <div style="display: flex;justify-content: space-between;height: 48%">
              <img :src="bussinessArr[1].filePath" alt="" style="width: 48%;height: 100%" />
              <img :src="bussinessArr[2].filePath" alt="" style="width: 48%;height: 100%" />
            </div>
            <div style="height: 48%">
              <img :src="bussinessArr[3].filePath" alt="" style="width: 100%;height: 100%" />
            </div>
          </div>
          <div style="width: 32%;height: 100%;display: flex;justify-content: space-between;flex-direction: column;">
            <img :src="bussinessArr[4].filePath" alt="" style="width: 100%;height: 48%" />
            <img :src="bussinessArr[5].filePath" alt="" style="width: 100%;height: 48%" />
          </div>
        </div>
      </div> -->
      <!-- 新增内容结束 -->

      <div class="midContentNew ">
        <img src="@/assets/images/homePic/about_title1.png" style="width: 300px; height: auto;">
      </div>
      <div class="midContentNew contentNewBtm">
        <div class="midContentText" v-html="companyInfo.aboutUS"></div>
      </div>

      <div class="midContentNew midTop">
        <img src="@/assets/images/homePic/about_title2.png" style="width: 300px; height: auto;">
      </div>
      <div class="midPicText contentNewBtm">
        <div class="midPicTextContent">
          <div><img src="@/assets/images/homePic/about_img2.png" style="width: 100%;height: auto;"></div>
          <span class="bigText midTitContent">经营理念</span>
          <span class="normalText midTitContent" style="width: 200px;">诚信为本，合作共赢</span>
        </div>
        <div class="midPicTextContent">
          <div><img src="@/assets/images/homePic/about_img3.png" style="width: 100%;height: auto;"></div>
          <span class="bigText midTitContent">企业愿景</span>
          <span class="normalText midTitContent" style="width: 200px;">以创新专业的优质服务，造福千家万户</span>
        </div>
        <div class="midPicTextContent">
          <div><img src="@/assets/images/homePic/about_img4.png" style="width: 100%;height: auto;"></div>
          <span class="bigText midTitContent">企业使命</span>
          <span class="normalText midTitContent" style="width: 200px;">科技为矛，创新为盾，推动健康产业的发展和进步！</span>
        </div>
        <div class="midPicTextContent">
          <div><img src="@/assets/images/homePic/about_img5.png" style="width: 100%;height: auto;"></div>
          <span class="bigText midTitContent">核心价值观</span>
          <span class="normalText midTitContent" style="width: 200px;">努力践行“人本、创新、发展、共赢”的核心价值观</span>
        </div>
      </div>

      <!-- <div class="midContentNew midTop">
        <div><img src="@/assets/images/homePic/weiLaiFaZhan.png" style="width: 300px; height: auto;"></div>
      </div>
      <div class="midPicTextLR midTop contentNewBtm">
        <div style="width: 100%;"><img src="@/assets/images/homePic/about_img7.png" alt="" srcset=""></div>
        <div style="width: 100%;" class="midPicRight">
          <span class="midTextNew midTextTit">携手共进、共创辉煌</span>
          <span class="midTextNew midTextTitEnglish">WORK TOGETHER TO CREATE BRILLIANT</span>
          <span
            class="midTextNew midTextContent">未来，公司将继续坚持以市场为导向，以发展为主题，以科技创新为核心，以坚持保护和增进人民身心健康，提高人民福祉为目标。努力把公司建设成为规范化、标准化、现代化、专业化的医药物流配送企业，以优质的服务和良好的企业形象持之以恒的与各界同仁加强合作，携手共进、共创辉煌！</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {
        Name: "",
        Phone: "",
        Email: "",
        CompanyName: "",
        LeaveMessage: "",
      },
      checkCode: "",
      NewsArr: [],
      socialArr: [],
      socialCont: [],
      bussinessArr: [
        { filePath: "" },
        { filePath: "" },
        { filePath: "" },
        { filePath: "" },
        { filePath: "" },
        { filePath: "" },
      ],
      // 顶部轮播图
      bannerImgs: [],
      // 中间简单介绍
      midContents: [],
      newsArr: [],
      qualityArr: [],
      nesCont: [],
      newsType: "公司新闻",
      socialType: "社会责任实践",
      tabList: [],
      goNewsId: '',
      companyInfo: {}
    };
  },
  computed: {},
  created() {
    this.searchTopImgFun();

    // 查询新闻中心
    this.initNewsFun();
    this.initNewsImgsFun()
    this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'))
    // // 查询社会责任
    // this.initSocialFun();
    // // 查看资质荣誉图片
    // this.lookQualityImgsFun();
    // // 查看业务领域图片
    // this.initBussinessAreaFun();
  },

  methods: {
    // 查询新闻中心
    initNewsFun(type = '') {
      this.Api.HomePageNewsSearchApi({
        type
      })
        .then(res => {
          this.nesCont = res.Data.news;
          this.tabList = res.Data.newsType
          this.goNewsId = res.Data.navigationId[0].id
          // console.log(res.Data);
        })
      // let data = {};
      // data.type = this.newsType;
      // data.pageIndex = 1;
      // data.pageSize = 7;
      // this.Api.NewsCenterManagementDataSearch_NewsApi(data).then((res) => {
      //   this.nesCont = res.Data;
      //   if (this.newsType == "公司新闻") {
      //     this.initNewsImgsFun(res.Data);
      //   }
      // });
    },
    // 查询新闻中心的图片
    initNewsImgsFun() {
      this.Api.NewsCenterManagementDataSearch_NewsPicturesApi().then((res) => {
        this.newsArr = [];
        let showPictureUrl = res.Data.documentsIISHttp;
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          let obj = {};
          obj.AOMID = res.Data.News[0].AOMID;
          obj.Author = res.Data.News[0].Author;
          obj.CreationTime = res.Data.News[0].CreationTime;
          obj.Title = res.Data.News[0].Title;
          obj.description = res.Data.News[0].description;
          obj.filePath =
            showPictureUrl +
            res.Data.pathfilename[i].dir +
            res.Data.pathfilename[i].filename;
          this.newsArr.push(obj);
        }
      });
    },
    // 新闻跳转到详情页
    routerFun(item) {
      this.$router.push({
        name: "all",
        params: { navigationId: this.goNewsId, type: 1 },
      });
    },
    // 查询社会责任
    initSocialFun() {
      let data = {};
      data.type = this.socialType;
      data.pageIndex = 1;
      data.pageSize = 7;
      this.Api.NewsCenterManagementDataSearch_SocialResponsibilityApi(
        data
      ).then((res) => {
        this.socialCont = res.Data;
      });
    },
    // 社会责任跳转到详情页
    routerSocialFun(item) {
      this.$router.push({
        name: "SX",
        query: {
          content: JSON.stringify(item),
        },
      });
    },
    // 查看资质荣誉图片
    lookQualityImgsFun() {
      this.Api.About0urManagementDataSearchimgApi({
        type: "资质荣誉",
      }).then((res) => {
        let that = this;
        that.showPictureUrl = res.Data.documentsIISHttp;
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.qualityArr.push(res.Data.pathfilename[i]);
        }
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.qualityArr[i].filePath =
            that.showPictureUrl +
            res.Data.pathfilename[i].dir +
            res.Data.pathfilename[i].filename;
        }
      });
    },
    // 通过首页图片跳转到资质荣誉详情页
    routeFun(val) {
      this.$router.push({
        name: "companyIntro",
        params: { activeId: val },
      });
    },
    // 业务领域首页图片查看
    initBussinessAreaFun() {
      this.Api.About0urManagementDataSearchimgApi({
        type: "物流运输",
      }).then((res) => {
        let that = this;
        that.showPictureUrl = res.Data.documentsIISHttp;
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.bussinessArr.push(res.Data.pathfilename[i]);
        }
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.bussinessArr[i].filePath =
            that.showPictureUrl +
            res.Data.pathfilename[i].dir +
            res.Data.pathfilename[i].filename;
        }
      });
    },
    // 更多跳转
    moreFun() {
      this.$router.push({
        name: "all",
        params: { navigationId: this.goNewsId, type: 1 },
      });

      // else if (val == "quality") {
      //   this.$router.push({
      //     name: "companyIntro",
      //     params: { activeId: 2 },
      //   });
      // } else if (val == "socity") {
      //   this.$router.push({
      //     name: "Risk",
      //     params: { activeId: 1 },
      //   });
      // } else if (val == "ywArea") {
      //   this.$router.push({
      //     name: "productClassify",
      //     params: { activeId: 1 },
      //   });
      // }
    },
    // 测试鼠标
    mouseEnterFun(type) {
      this.initNewsFun(type)
      // this.newsType = val.target.innerText;
      // if (this.newsType == "公司新闻" || this.newsType == "行业动态") {
      //   this.initNewsFun();
      // } else {
      //   this.socialType = val.target.innerText;
      //   this.initSocialFun();
      // }
    },
    // 头部轮播图图片
    searchTopImgFun() {
      this.Api.SearchHomePageFilesApi({ type: "top" }).then((res) => {
        let url = res.Data.documentsIISHttp;
        let arr = res.Data.files;
        for (let i = 0; i < arr.length; i++) {
          let obj = {};
          obj.img = url + arr[i].filePath;
          this.bannerImgs.push(obj);
        }
      });
    },
    Goylkt(index) {
      if (index == 0) {
        this.$router.push("/companyIntro/companyIntro");
      } else if (index == 1) {
        this.$router.push("/forum/forumClassroom");
      } else if (index == 2) {
        this.$router.push("Risk/SiXiang");
      } else {
        this.$router.push("/ProductClassify/productClassify");
      }
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #000;
}

a:hover {
  color: #0068b7;
}

.midCompany {
  width: 100%;
  height: 500px;
  margin: 30px auto 130px;
  display: flex;
  justify-content: space-between;
}

.carousel {
  width: 45%;
}

.midContent {
  width: 55%;
  box-sizing: border-box;
  padding-left: 20px;
}

.midTit {
  font-size: 20px;
  color: #999999;
  font-weight: 800;
  // font-family: "微软雅黑", "黑体";
  display: flex;
}

.midContents {
  display: flex;
  justify-content: space-between;
  color: #646464;
  padding: 0 10px;
  line-height: 25px;
  height: 30px;
  border-bottom: 1px solid #ccc;
}

.midTitBox {
  display: block;
  width: 180px;
  text-align: center;
}

.midTitBox:hover {
  color: #000;
  border-bottom: 3px solid #0068b7;
  cursor: pointer;
}

.other {
  border: none;
}

.more:hover {
  color: #0068b7;
  cursor: pointer;
}

.newsTit {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  width: 100%;
}

.zzStart {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: space-between;
}

.zzStyle {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // border: 1px solid #f00;
}

.zzTit {
  font-size: 20px;
  font-weight: 800;
  border-bottom: 5px solid #0068b7;
}

.ywStyle {
  margin: 10px 0;
  border-bottom: 1px solid #ccc;
}

.bottomPic {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.container {
  width: 100%;
  background: rgb(255, 255, 255);
  margin-top: 10px;
}

.big {
  background: #fff;
  width: 80%;
  margin: 0 auto;
}

img {
  width: 794px;
  height: 321px;
}

/deep/.is-active {
  border-bottom: 0px;
}

.midContentNew {
  display: flex;
  justify-content: center;
  width: 100%;
  // flex-direction: column;
  flex-wrap: wrap;
  margin-top: 20px;
}

.midContentText {
  font-size: 19px;
  line-height: 2.1;
  width: 100%;
  padding: 20px;
  color: #666;
}

.midTop {
  margin-top: 100px;
}

.midPicText {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
  padding-top: 80px;
}

.midPicTextContent {
  display: flex;
  justify-content: center;
  // flex-direction: column;
  flex-wrap: wrap;
  width: 25%;
}

.bigText {
  font-weight: 800;
  font-size: 20px;
  margin: 20px 0;
}

.normalText {
  color: #666;
  font-size: 18px;
}

.midTitContent {
  display: block;
  width: 100%;
  text-align: center;
}

.midPicTextLR {
  display: flex;
  justify-content: space-between;
}

.midPicTextLR img {
  width: 80%;
  height: auto;
  border-radius: 30px;
}

.midTextNew {
  display: block;
}

.midPicRight {
  box-sizing: border-box;
  padding: 20px;
}

.midTextTit {
  font-weight: 800;
  font-size: 40px;
  color: #f29e1c;
}

.midTextTitEnglish {
  font-size: 20px;
  color: #ccc;
  margin: 10px 0 30px;
}

.midTextContent {
  line-height: 1.8;
  color: #666;
  font-size: 18px;
}

.contentNewBtm {
  margin-bottom: 200px;
}
</style>
